<template>
    <!--##############################################################################################
#####   For use this component he need one props named "options" made up of :
#####      * One "title"
#####     * Into options one array named "items" made up of :
#####         * One key "titleRadio" for title and "label" for the label for the radio
#####        * One key "selectData" for the data into the select (into this array, place one key "data" for so that the display be unique )
##### The props radio is optional for set or not the radio
#####
##### The return is "row" for the value of the select and "radio" for the value of radio
###################################################################################################-->

    <!-- TITLE OF THE BLOCK -->
    <el-form-item :label="options.title" class="">
        {{ options.items.length }}
        <div
            v-for="(item, index) in options.items"
            :key="item.label"
            class="well flex-level wfull radio-select-link__item"
            :class="containerClass(index)"
        >
            <!-- RADIO CHOICE -->
            <CompassRadio
                :checked="radio === item.label"
                :label="item.titleRadio"
                @change="updateRadio($event, item.label)"
            />

            <el-form-item prop="select" class="flex-right">
                <CompassSelect
                    v-model="item.data"
                    :disabled="radio !== item.label"
                    menuClass="radio-select-link__menu"
                    @update:modelValue="updateSelect"
                >
                    <CompassDropdownOption
                        v-for="row in item.selectData"
                        :key="row.value"
                        :label="row.label"
                        :value="row.value"
                    />
                </CompassSelect>
            </el-form-item>
        </div>
    </el-form-item>
</template>

<script>
export default {
    props: {
        options: {
            type: Object,
            required: true,
        },
        radioSelected: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            radio: this.radioSelected !== '' ? this.radioSelected : '',
        };
    },
    methods: {
        updateSelect(row) {
            this.$emit('updateSelect', { select: row });
        },
        updateRadio(checked, row) {
            if (checked) {
                this.radio = row;
                this.$emit('updateRadio', { radio: row });
            }
        },
        containerClass(index) {
            return {
                'bb-0 br-bottom-0': index == 0,
                'br-top-0': index == Object.keys(this.options.items).length - 1,
            };
        },
    },
};
</script>

<style scoped lang="scss">
.radio-select-link__item {
    gap: var(--spacing-1);
    justify-content: space-between;
}
</style>

<style lang="scss">
#compass-dropdown-container {
    .radio-select-link__menu {
        z-index: 1001;
    }
}
</style>
